import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Animated, Easing } from 'react-native';
import i18n from 'i18n-js';

class ScanArea extends React.Component {
  constructor(props) {
    super(props);
    this.scanLineAnim = new Animated.Value(0);
  }

  componentDidMount() {
    if (this.props.isScanning) {
      this.startAnimation();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isScanning && !prevProps.isScanning) {
      this.startAnimation();
    } else if (!this.props.isScanning && prevProps.isScanning) {
      this.stopAnimation();
    }
  }

  startAnimation = () => {
    this.scanLineAnim.setValue(0);
    Animated.loop(
      Animated.timing(this.scanLineAnim, {
        toValue: 1,
        duration: 2000,
        easing: Easing.linear,
        useNativeDriver: false, // width/top/left layout properties require false
      })
    ).start();
  };

  stopAnimation = () => {
    this.scanLineAnim.setValue(0);
  };

  render() {
    const { isScanning, onTap, bottomControls } = this.props;

    const scanLineTop = this.scanLineAnim.interpolate({
      inputRange: [0, 1],
      outputRange: ['0%', '100%'],
    });

    return (
      <View style={[styles.container, bottomControls && { top: 10, bottom: 50 }]}>
        <TouchableOpacity
          style={[styles.scanAreaTouchable, bottomControls && { aspectRatio: 1.8 }]}
          onPress={onTap}
          activeOpacity={0.8}
          testID="scanArea"
        >
          <View style={styles.scanArea}>
            {/* Corners */}
            <View style={[styles.corner, styles.tl]} />
            <View style={[styles.corner, styles.tr]} />
            <View style={[styles.corner, styles.bl]} />
            <View style={[styles.corner, styles.br]} />

            {/* Scanning Line */}
            {isScanning && (
              <Animated.View style={[styles.scanLine, { top: scanLineTop }]} />
            )}

            {!isScanning && (
              <Text style={styles.tapToScanText}>
                {i18n.t('camScanner.tapToScan', { defaultValue: 'Tap to Scan' })}
              </Text>
            )}
          </View>
        </TouchableOpacity>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 40,
    left: 0,
    right: 0,
    bottom: 40,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 5,
  },
  scanAreaTouchable: {
    width: '85%',
    aspectRatio: 1.5,
    maxWidth: 400,
  },
  scanArea: {
    flex: 1,
    borderWidth: 2,
    borderColor: 'rgba(255, 255, 255, 0.25)',
    backgroundColor: 'transparent',
    position: 'relative',
    justifyContent: 'center',
    borderRadius: 8,
  },
  corner: {
    position: 'absolute',
    width: 24,
    height: 24,
    borderColor: '#00ff88',
    borderStyle: 'solid',
  },
  tl: {
    top: -2,
    left: -2,
    borderLeftWidth: 4,
    borderTopWidth: 4,
    borderTopLeftRadius: 8,
  },
  tr: {
    top: -2,
    right: -2,
    borderRightWidth: 4,
    borderTopWidth: 4,
    borderTopRightRadius: 8,
  },
  bl: {
    bottom: -2,
    left: -2,
    borderLeftWidth: 4,
    borderBottomWidth: 4,
    borderBottomLeftRadius: 8,
  },
  br: {
    bottom: -2,
    right: -2,
    borderRightWidth: 4,
    borderBottomWidth: 4,
    borderBottomRightRadius: 8,
  },
  scanLine: {
    position: 'absolute',
    left: 0,
    right: 0,
    height: 2,
    backgroundColor: '#00ff88',
  },
  tapToScanText: {
    position: 'absolute',
    padding: 20,
    alignSelf: 'center',
    color: 'rgba(255, 255, 255, 0.85)',
    fontSize: 20,
    fontFamily: 'Poppins_300Light',
    textAlign: 'center',
    fontWeight: '300',
    letterSpacing: 0.4,
  },
});

export default ScanArea;
